import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import Button, { DangerButton, TextButton } from '../../common/Button'
import { FormTitle, MedBodyText } from '../../styles/Text'
import { DialogActionsRow, FlexDialogContent, StyledDialog } from '../../styles/Containers'

const DIALOG_ACTION_BUTTON_PADDING = '7px 20px'

const Content = styled(FlexDialogContent)`
  padding: 30px;
  gap: 15px;
  max-width: 480px;
`

const KeepEditingButton = styled(TextButton)`
  margin-right: auto;
  padding: 0;
  text-decoration: none;
  white-space: nowrap;
`

const DiscardChangesButton = styled(DangerButton)`
  padding: ${DIALOG_ACTION_BUTTON_PADDING};
  white-space: nowrap;
`

const SaveAndContinueButton = styled(Button)`
  padding: ${DIALOG_ACTION_BUTTON_PADDING};
  white-space: nowrap;
`

const Title = styled(FormTitle)`
  font-weight: 600;
`

function UnsavedChangesDialog({ open, editCount, saving = false, onKeepEditing, onDiscard, onSaveAndContinue }) {
  const edits = editCount === 1 ? '1 edit' : `${editCount} edits`
  return (
    <StyledDialog open={open} onClose={onKeepEditing} aria-labelledby="unsaved-redaction-changes-title" maxwidth="540px">
      <Content>
        <Title id="unsaved-redaction-changes-title">Unsaved redaction changes</Title>
        <MedBodyText>
          You have {edits} that are not saved to the redactions-noted PDF. Save them now, or discard them to leave without changing the file.
        </MedBodyText>
        <DialogActionsRow>
          <KeepEditingButton onClick={onKeepEditing}>Keep editing</KeepEditingButton>
          <DiscardChangesButton onClick={onDiscard}>Discard changes</DiscardChangesButton>
          <SaveAndContinueButton onClick={onSaveAndContinue} loading={saving}>
            Save &amp; continue
          </SaveAndContinueButton>
        </DialogActionsRow>
      </Content>
    </StyledDialog>
  )
}

UnsavedChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  editCount: PropTypes.number.isRequired,
  saving: PropTypes.bool,
  onKeepEditing: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onSaveAndContinue: PropTypes.func.isRequired
}

export default UnsavedChangesDialog
